var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.dataHasLoaded)?_c('div',{staticClass:"work-new-form justify-center"},[_c('handle-form',{attrs:{"parentData":{ method: 'create', item: _vm.item, form_title: _vm.form_data.form_header.title.add, title_icon_path: _vm.title_icon_path, path: _vm.path, grid: _vm.grid, data: _vm.form_data }},on:{"close-form":_vm.closeForm}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }